<template>
    <div class="bg-white border-light">
        <!-- Modo lectura: muestra el valor formateado -->
        <div
            :class="'input-formatter ' + input_class + (disabled_input ? ' bg-light' : '')"
            v-if="!isInputActive || disabled_input"
            @click="activateEdit"
            style="cursor: text; padding: 3px 0"
            class="disabled_input}"
        >
            <span v-html="formattedDisplay"></span>
        </div>

        <!-- Modo edición: muestra el input crudo -->
        <input
            v-else
            ref="realInput"
            :id="id"
            :name="name"
            :disabled="disabled_input"
            :class="'form-control form-control-sm ' + input_class"
            type="text"
            v-model="rawValue"
            @blur="onBlur"
            @change="onChange"
        />
    </div>
</template>

<script>
export default {
    name: 'input_formatter',
    props: {
        id: {type: String, default: 'input_formatter'},
        name: {type: String, default: 'input_formatter'},
        disabled_input: {type: Boolean, default: false},
        input_class: {type: String, default: ''},
        value: {type: [Number, String], default: null},
        decimals: {type: Number, default: 2},
        symbol: {type: String, default: ''},
        position_symbol: {type: Boolean, default: true},
        readonly: {type: Boolean, default: false}
    },
    data() {
        return {
            isInputActive: false
        };
    },
    computed: {
        /**
         * Valor que se muestra en modo edición (input “crudo”).
         */
        rawValue: {
            get() {
                return this.value !== null ? String(this.value) : '';
            },
            set(newVal) {
                // Eliminar todo lo que no sea dígito o punto decimal
                let parsed = parseFloat(newVal.replace(/[^\d.]/g, ''));
                if (isNaN(parsed)) {
                    parsed = 0;
                }
                this.$emit('input', parsed);
            }
        },

        /**
         * Valor formateado en HTML para mostrar cuando NO se edita.
         * - Separa la parte entera y la parte decimal.
         * - Destaca los dos primeros decimales y atenúa el resto.
         * - Añade separador de miles a la parte entera.
         * - Ubica el símbolo (si existe) a la izquierda o a la derecha.
         */
        formattedDisplay() {
            let number = parseFloat(this.value);
            if (isNaN(number)) {
                return '';
            }

            // Ajusta el número a la cantidad total de decimales
            let formatted = number.toFixed(this.decimals);

            // Separar parte entera y parte decimal
            let [intPart, decPart = ''] = formatted.split('.');
            // Formatear la parte entera con separadores de miles
            intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            // Destacar los primeros dos decimales y atenuar el resto (si existiera)
            let highlightedDecimals;
            if (decPart.length > 2) {
                highlightedDecimals =
                    decPart.slice(0, 2) +
                    `<span style="opacity: 0.4;">${decPart.slice(2)}</span>`;
            } else {
                highlightedDecimals = decPart;
            }

            // Reconstruir el número formateado
            let finalNumber = intPart;
            if (decPart.length) {
                finalNumber += '.' + highlightedDecimals;
            }

            // Añadir el símbolo a la izquierda o derecha
            if (this.symbol) {
                finalNumber = this.position_symbol
                    ? this.symbol + ' ' + finalNumber
                    : finalNumber + ' ' + this.symbol;
            }

            return finalNumber;
        }
    },
    methods: {
        activateEdit() {
            // Activamos el modo edición
            this.isInputActive = true;
            this.$nextTick(() => {
                // Intentamos enfocar el input tan pronto se muestre
                if (this.$refs.realInput) {
                    this.$refs.realInput.focus();
                    this.$refs.realInput.select();
                }
            });
        },
        onBlur() {
            this.isInputActive = false;
        },
        onChange(e) {
            this.$emit('changeInput', e.target.value);
        }
    }
};
</script>

<style>
.input-formatter {
    border: 1px solid #d7d7d7;
    border-radius: 3px;
}
</style>
